<template>
  <div>
    <page-title>Polls</page-title>

    <loading v-if="loading" />

    <div v-else>
      <section-block>
        <template slot="header">
          <filter-bar
            resource="Polls"
            :search-query="searchQuery"
            show-search
          ></filter-bar>
        </template>

        <template slot="actions">
          <base-button
            :primary="true"
            @click="$router.push({ name: 'AdminPollsCreate' })"
            iconBefore="document-create"
            v-if="userCanAdd"
          >
            <span>Create a poll</span>
          </base-button>
        </template>

        <vuetable
          class="c-data-table"
          :api-mode="false"
          :fields="table.fields"
          :data-manager="dataManager"
          pagination-path
          ref="pollsTable"
          @vuetable:pagination-data="onPaginationData"
          :row-class="onRowClass"
        >
          <template slot="title" slot-scope="props">
            <span v-if="props.rowData.title">{{ props.rowData.title }}</span>
            <span v-else>Not set</span>
          </template>
          <template slot="date-created" slot-scope="props">
            <base-datetime :date="props.rowData.created_time"></base-datetime>
          </template>

          <template slot="submissions" slot-scope="props">
            <span>n / a</span>
          </template>

          <template slot="category-actions" slot-scope="props">
            <poll-actions
              routePath="AdminPollsEdit"
              type="Poll"
              :id="props.rowData.id"
              deleteAction="Polls/delete"
              :rowData="props.rowData"
              @tableUpdate="updateTable"
              :can-delete="userCanDelete"
            />
          </template>
        </vuetable>
        <pagination table-pagination>
          <vuetable-pagination
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </pagination>
      </section-block>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Pagination from "@/components/pagination";
import PollActions from "@/modules/polls/components/PollActions";
import UserHasPermission from "@/mixins/UserHasPermission";
export default {
  name: "PollsAdminIndex",

  components: {
    PollActions,
    Pagination,
    VuetablePagination,
  },
  mixins: [UserHasPermission],
  data() {
    return {
      loading: true,
      searchQuery: null,
      table: {
        fields: [
          {
            name: "title",
            titleClass: "u-ta-left",
            title: "Poll Title",
            width: "30%",
          },
          {
            name: "date-created",
            titleClass: "u-ta-left",
            title: "Date Created",
            width: "30%",
          },
          {
            name: "submissions",
            titleClass: "u-ta-left",
            title: "Submissions",
            width: "30%",
          },
          {
            name: "category-actions",
            title: "Actions",
            titleClass: "u-ta-center u-hide-mobile",
            dataClass: "u-ta-center u-hide-mobile",
            width: "10%",
          },
        ],
      },
    };
  },

  computed: {
    ...mapState("Polls", ["pagination", "polls"]),
    userCanAdd() {
      return this.userHasPermission("add_polls");
    },
    userCanDelete() {
      return this.userHasPermission("delete_polls");
    },
  },

  watch: {
    polls(newValue, oldValue) {
      if (newValue && newValue.length !== oldValue.length) {
        this.updateTable();
      }
    },
  },

  mounted() {
    this.$store.dispatch("Polls/list", { flat: true }).then((resp) => {
      this.loading = false;
    });
  },
  methods: {
    onRowClass(item, index) {
      return item.status && item.status === "active" ? "bg-active" : "";
    },
    updateTable() {
      this.$refs.pollsTable.refresh();
    },
    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.pagination,
        data: this.polls,
      };

      return returnObj;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      const vm = this;
      const tableref = vm.$refs.pollsTable;
      let nextPage;
      this.loading = true;

      switch (page) {
        case "next":
          nextPage = ++this.$store.state.Polls.pagination.current_page;
          break;
        case "prev":
          nextPage = --this.$store.state.Polls.pagination.current_page;
          break;
        default:
          nextPage = page;
          break;
      }
      this.$store
        .dispatch("Polls/list", {
          page: nextPage,
          flat: true,
        })
        .then((resp) => {
          window.scroll(0, 0);
          tableref.changePage(nextPage);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.bg-active {
  background: lighten($colour-nhs-light-green, 50%);
}
</style>
